<template>
  <div class="user-search-form">
    <template v-if="$root.isAdminager">
      <h3 class="mb-4">
        Who would you like to enroll in this {{ enrollableType.toLowerCase() }}?
      </h3>

      <template v-if="!advancedSearch">
        <div class="search-input-wrap mb-2">
          <a
            href="#"
            class="search-input-icon"
            title="Search"
            @click.prevent="search()"
          >
            <icon icon="search" class="svg-icon" />
          </a>
          <div class="element">
            <input
              type="text"
              name="keywords"
              class="search-input form-control"
              placeholder="Search for others by name, ID or company"
              v-model="keywords"
              @keyup.enter="search()"
              @keyup.esc="reset()"
              @keyup="searchAfterDelay()"
            />
          </div>
          <a
            v-if="keywords.length > 0"
            class="search-input-clear"
            href="#"
            @click.prevent="reset()"
          >
            <icon icon="plus" class="svg-icon" />
          </a>
        </div>
        <div class="mb-3">
          <a
            href="#"
            @click.prevent="searchTypeToggle(true)"
            class="font-size-sm"
            >Show Advanced Search</a
          >
        </div>
      </template>

      <template v-else>
        <div class="row mb-2">
          <div class="col-12 col-sm-6 col-md-3 col-lg-6 col-xl-3 mb-3">
            <Field
              type="text"
              label="First Name"
              name="first_name"
              v-model="first_name"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-3 col-lg-6 col-xl-3 mb-3">
            <Field
              type="text"
              label="Last Name"
              name="last_name"
              v-model="last_name"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-3 col-lg-6 col-xl-3 mb-3">
            <Field
              type="text"
              label="HVAC ID"
              name="hvac_id"
              v-model="hvac_id"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-3 col-lg-6 col-xl-3 mb-3">
            <Field type="text" label="Email" name="email" v-model="email" />
          </div>
          <div class="col-12 col-sm-6 col-md-3 col-lg-6 col-xl-3 mb-3 mb-sm-0">
            <Field
              type="text"
              label="Company"
              name="company"
              v-model="company"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-3 col-lg-6 col-xl-3">
            <Field type="text" label="City" name="city" v-model="city" />
          </div>
        </div>
        <div class="mb-3">
          <a
            href="#"
            @click.prevent="searchTypeToggle(false)"
            class="font-size-sm"
            >Hide Advanced Search</a
          >
        </div>
      </template>
      <div>
        <a href="#" @click.prevent="search()" class="btn btn-primary mr-2"
          >Submit Search</a
        >
        <a
          v-if="enrollableType === 'Event'"
          class="btn btn-success"
          href="#"
          @click.prevent="addWriteIn()"
          >Add Write-In</a
        >
      </div>
    </template>

    <template v-else>
      <h3 class="mb-4">Enroll others from your company</h3>
    </template>

    <UserSearchResults
      :listing-url="searchUrl"
      :columns="columns"
      :defaultParams="defaultParams"
      :searchParams="searchParams"
      :coworkers="coworkers"
      @add-to-queue="addToQueue"
    />
  </div>
</template>

<script>
import UserSearchResults from "./UserSearchResults";
export default {
  components: { UserSearchResults },

  props: {
    enrollableType: { type: String, required: true },
    enrollableId: { type: Number, required: true },
    coworkers: { type: Array, default: () => [] },
  },

  data() {
    return {
      keywords: "",
      advancedSearch: false,
      first_name: "",
      last_name: "",
      email: "",
      hvac_id: "",
      company: "",
      city: "",
      defaultParams: {
        columns: ["name", "email", "company_name", "brand"],
      },
      searchParams: {},
      searchTimeout: null,
    };
  },

  computed: {
    columns() {
      return [
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
        },
        {
          key: "company_name",
          label: "Company",
          sortable: true,
        },
        {
          key: "brand",
          label: "Brand",
          sortable: false,
        },
      ];
    },
    searchUrl() {
      var routeName = "";
      var routeParam = {};
      if (this.enrollableType === "Course") {
        routeName = "enroll.online.course.queue.search";
        routeParam = { course: this.enrollableId };
      } else if (this.enrollableType === "Event") {
        routeName = "enroll.classroom.event.queue.search";
        routeParam = { event: this.enrollableId };
      } else if (this.enrollableType === "Learning Path") {
        routeName = "enroll.online.learning-path.queue.search";
        routeParam = { learning_path: this.enrollableId };
      }
      return this.route(routeName, routeParam);
    },
  },

  methods: {
    search() {
      if (this.advancedSearch) {
        this.searchParams = {
          ...{ "custom_search[first_name]": this.first_name },
          ...{ "custom_search[last_name]": this.last_name },
          ...{ "custom_search[hvac_id]": this.hvac_id },
          ...{ "custom_search[email]": this.email },
          ...{ "custom_search[company]": this.company },
          ...{ "custom_search[city]": this.city },
        };
      } else {
        this.searchParams = {
          ...(this.keywords.length > 0 ? { keywords: this.keywords } : {}),
        };
      }
    },
    searchAfterDelay() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.search();
      }, 300);
    },
    reset() {
      this.keywords = "";
      this.first_name = "";
      this.last_name = "";
      this.email = "";
      this.hvac_id = "";
      this.company = "";
      this.city = "";
    },
    addToQueue(user) {
      this.$emit("add-to-queue", user);
    },
    addWriteIn() {
      this.$emit("add-write-in");
    },
    searchTypeToggle(advanced) {
        this.advancedSearch = advanced;
        this.reset();
    }
  },
};
</script>